import RoutesMap from "route_control/RouteControl"
import { UserRoleList, ModuleList, ActionList, AddAction, UpdateAction, Permission, EntityPermissionList, GlobalControl, Services, GlobalSettings, IpAndAccess } from "pages/settings"

const SettingsRoute = () => {
    return [
        {
            path: RoutesMap.MODULE_LIST.path,
            element: <ModuleList />
        },

        {
            path: RoutesMap.USER_ROLE_LIST.path,
            element: <UserRoleList />
        },

        {
            path: RoutesMap.ACTION_LIST.path,
            element: <ActionList />
        },
        {
            path: RoutesMap.ADD_ACTION.path,
            element: <AddAction />
        },
        {
            path: RoutesMap.UPDATE_ACTION.path,
            element: <UpdateAction />
        },

        {
            path: RoutesMap.PERMISSION.path,
            element: <Permission />
        },
        {
            path: RoutesMap.ENTITY_PERMISSION_LIST.path,
            element: <EntityPermissionList />
        },

        {
            path: RoutesMap.GLOBAL_CONTROL.path,
            element: <GlobalControl />
        },
        {
            path: RoutesMap.SERVICES.path,
            element: <Services />
        },
        {
            path: RoutesMap.GLOBAL_SETTINGS.path,
            element: <GlobalSettings />
        },
        {
            path: RoutesMap.IP_AND_ACCESS.path,
            element: <IpAndAccess />
        },
    ]
}

export default SettingsRoute;